import request from '@/api/request'

/**
 * 获取退役军人培训资讯列表
 */
export const getVeteranListByType = (params) => {
  return request({
    url: '/radioweb/app/web/getVeteranListByType',
    method: 'get',
    params
  })
}

/**
 * 获取退役军人培训咨询详情
 */
export const getVeteranDescById = (params) => {
  return request({
    url: '/radioweb/app/web/getVeteranDescById',
    method: 'get',
    params
  })
}

/**
 * 获取退役军人培训
 */
export const getVeteranByType = (params) => {
  return request({
    url: '/radioweb/app/veteran/getVeteran',
    method: 'get',
    params
  })
}
